import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-tabs";
import BaseSearchPaging2 from "./../../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialog from "./../../factories/bao-dialog";
class AreaViewModel extends BaseSearchPaging2 {
    ShortName: KnockoutObservable<string>;
    AreaEquipmentDetailTabPage: TabPage;
    ShiftbookAreaTabPage: TabPage;
    constructor(tabPage: TabPage) {
        super(tabPage);
        // hack only necessary until next bao update
        this["PermissionForward"] = "AreaForward";
        this["PermissionBackward"] = "AreaBackward";
        // hack end
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.ShortName())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        //return "";
        return "MasterData/Area/Init";
    }
    init() {
        //after base init, load tabs
        return super.init().then(() => {
            //load tabs
            return super.InitTabController().then(() => {
                this.AreaEquipmentDetailTabPage = new TabPage();
                this.AreaEquipmentDetailTabPage.IsClosable(false);
                this.AreaEquipmentDetailTabPage.Url("MasterData/AreaEquipmentDetailTab");
                this.TabController.AddTab(this.AreaEquipmentDetailTabPage);
                this.ShiftbookAreaTabPage = new TabPage();
                this.ShiftbookAreaTabPage.IsClosable(false);
                this.ShiftbookAreaTabPage.Url("MasterData/ShiftbookAreaTab");
                this.ShiftbookAreaTabPage.AutoSelect = false;
                this.TabController.AddTab(this.ShiftbookAreaTabPage);
            });
        });
    }
}
export default AreaViewModel;